import React from 'react'
import ConfigurationContainer from './ConfigurationContainer'

const Configuration = () => <ConfigurationContainer data-test="component-configuration-container" />
export default Configuration
